export const DEFAULT_CALENDAR_VISIBILITY = {
  events: true,
  birthdays: true,
  tasks: true,
} as const;
